/**
 * Posting rules shared by every job form (recruiter Manage Jobs, the SMAART /
 * job-fair PostJobModal, and the college Placement Office). One place to change
 * the rules; every form validates identically.
 */

export const MIN_MUST_HAVE_SKILLS = 5;

/**
 * Salary must be a RANGE ("3 - 5", "3.5-6", "12 – 15"), not a single figure.
 * Unpaid postings skip the check. Returns an error message or '' when valid.
 */
export const validateSalaryRange = (amount, period) => {
  if (period === 'Unpaid') return '';
  // Strip thousands separators so "15,000 - 20,000" (monthly stipends) parses.
  const s = String(amount || '').trim().replace(/,/g, '');
  if (!s) return 'Please enter the salary package as a range, e.g. 3 - 5';
  // two numbers separated by a dash (hyphen / en-dash / em-dash), spaces optional
  const m = s.match(/^(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)$/);
  if (!m) return 'Salary must be a range like 3 - 5, not a single figure';
  const lo = parseFloat(m[1]);
  const hi = parseFloat(m[2]);
  if (!(hi > lo)) return 'Salary range must go from lower to higher, e.g. 3 - 5';
  return '';
};

/**
 * At least MIN_MUST_HAVE_SKILLS skills flagged as must-have. Returns an error
 * message or '' when valid.
 */
export const validateMustHaveSkills = (structuredSkills) => {
  const count = (structuredSkills || []).filter(s => s && s.isEssential).length;
  if (count < MIN_MUST_HAVE_SKILLS) {
    return `Add at least ${MIN_MUST_HAVE_SKILLS} must-have skills (currently ${count})`;
  }
  return '';
};

/**
 * An 'upcoming' drive needs the day it opens — student feeds hide upcoming
 * jobs and auto-open them on this date. Returns an error message or ''.
 */
export const validateUpcomingDate = (status, openingDate) => {
  if (status !== 'upcoming') return '';
  if (!openingDate) return 'Please set the date this upcoming drive opens on';
  const d = new Date(openingDate);
  if (Number.isNaN(d.getTime())) return 'Drive opening date is not a valid date';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  if (d < today) return 'Drive opening date must be today or later — pick Open if it has already started';
  return '';
};
